import { getUserIp } from '@src/quince-site-common/src/services/ipService/ipService'
import AuthUtil from '@src/quince-site-common/src/utils/authUtil'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import { generateHashCode } from '@src/quince-site-common/src/utils/stringUtil'
import { initializeScript } from '@src/telemetry/integrations/provider-utils/initialize-script'
import { getSessionId } from '@src/utils/user/session.browser'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'
import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'

const pbbl_iframe_url = 'http://cdn.pbbl.co/i/pp.html'
const brid = '2772'

export const PebblePost = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.PEBBLE_POST,
  },

  events: {
    [TELEMETRY_EVENT_NAMES.PAGE_VIEW]: async () => {
      /**
       * The tracking is handled by loading a script on each page visit.
       * Normally, we load scripts on gatsby browser, but it only includes and exports the script once.
       * For these, we need to re-run those scripts on each view
       * And hence we first remove the existing script and re-load a new one.
       * The config had 'id' in attributes, which takes care of removing before inserting a new one.
       */
      for (const iframe of document.getElementsByTagName('iframe')) {
        if (iframe && iframe.src === pbbl_iframe_url) {
          iframe.remove()
        }
      }
      const ipAddress = await getUserIp()
      // take care of initilization
      window._pp = window._pp ?? []
      window._pp.brid = brid

      if (AuthUtil.isLoggedIn()) {
        const email = getCookie(ANALYTIC_COOKIES.LB_CUSTOMER_EMAIL) ?? ''
        window._pp.brcid = generateHashCode(email).toString()
      } else {
        window._pp.brcid = ''
      }

      window._pp.sessionId = '' + getSessionId()
      window._pp.customerIp = ipAddress ?? ''

      await initializeScript({
        key: 'pebble-post',
        domain: TELEMETRY_DOMAINS.PEBBLE_POST,
        path: `/r/${brid}.js`,
        attributes: {
          id: 'pebblepost', // takes care of de-dupe
        },
        injectAt: 'beforeFirstScript',
      })
    },
  },
}
